import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers } from "../module_auth/AuthService"
import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { formatDate, getUniqNewsUrl, sendGoogleAnalytics, 
    forbiddenContentCopy, scrollTop } from "./common/BaseUtil"
//icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { faClock, faUser } from '@fortawesome/free-regular-svg-icons';
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from 'react-helmet';

export function News() {
    const location = useLocation();
    const { id, slug } = useParams();

    //블로그상세
    const [newsTitle, setNewsTitle] = useState("");
    const [newsContent, setNewsContent] = useState("");
    const [summary, setSummary] = useState("");
    const [updateAt, setUpdateAt] = useState("");
    const [fileSource, setFileSource] = useState("");
    const [hits, setHits] = useState(0);

    //파일
    const [fileName, setFileName] = useState("");
    const [fileFormat, setFileFormat] = useState("");
    const [uniqFileName, setUniqFileName] = useState("");
    //End 블로그상세

    useEffect(() => {
        sendGoogleAnalytics(location.pathname);
        forbiddenContentCopy();
        scrollTop();
        
        let url = basePort + '/get/news/' + id
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setNewsTitle(response.newsTitle)
                setNewsContent(response.newsContent)
                setSummary(response.summary == null ? "" : response.summary)
                setUpdateAt(response.updateAt)
                setFileSource(response.fileSource)
                setHits(response.hits)
                if (response.fileName) {
                    setFileName(response.fileName)
                    setFileFormat(response.fileFormat)
                    setUniqFileName(response.uniqFileName)
                }
            }).catch(error => console.log(error))
    }, []);

    let navigate = useNavigate();
    function backToList() {
        let page = localStorage.getItem("page")
        let pageList = page == null ? 1 : page
        let url = "/news_list?page=" + pageList;
        navigate(url);
    }

    return (
        <div>
            <Helmet>
                <title>지워커 | {newsTitle} </title>
                <meta name="description" content={summary} />
                <script type="application/ld+json">
                    {`
                    {
                    "@context": "https://schema.org",
                    "@type": "NewsArticle",
                    "headline": "${newsTitle}",
                    "image": "${getUniqNewsUrl(uniqFileName, fileFormat)}",
                    "author": {
                        "@type": "Person",
                        "name": "G-Worker"
                    },
                    "publisher": {
                        "@type": "Organization",
                        "name": "G-Worker",
                        "logo": {
                            "@type": "ImageObject",
                            "url": "https://www.g-worker.co.kr/gworker_logo.png"
                        }
                    },
                    "datePublished": "${updateAt}",
                    "dateModified": "${updateAt}",
                    "description": "${summary}",
                    "mainEntityOfPage": {
                        "@type": "WebPage",
                        "@id": "https://www.g-worker.co.kr/news?id=${id}"
                    }
                    }
                    `}
                </script>
            </Helmet>
            <main class="page lanidng-page">
                <article itemScope itemType="https://schema.org/NewsArticle">
                    <div class="container" style={{ paddingTop: '100px', marginTop: '10px', marginBottom: '10px' }}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>독일뉴스</span></li>
                            <li class="breadcrumb-item"><span>최신뉴스</span></li>
                        </ol>
                        <div class="container">
                            <div class="card" style={{ marginBottom: '10px', marginTop: '10px' }}>
                                <div class="card-body">
                                    {/* 제목 */}
                                    <header>
                                        <h1 itemProp="headline" class="card-title" style={{ fontSize: '24px', fontFamily: 'Nanum Gothic', fontWeight: 'bold', marginBottom: '20px' }}>{newsTitle}</h1>
                                        <div class="row" style={{ marginBottom: "30px" }}>
                                            <label class="form-label">
                                                <span><FontAwesomeIcon icon={faClock} /> <time dateTime={updateAt} itemProp="datePublished">{formatDate(updateAt)}</time> <FontAwesomeIcon icon={faEye} style={{ marginLeft: "10px" }}/> {hits}</span>
                                            </label>
                                        </div>
                                    </header>

                                    {/* 요약 */}
                                    <p class="card-text" itemProp="description">
                                        <span style={{ color: '#222222' }}>
                                            {parse(summary)}
                                        </span><br /><br />
                                    </p>

                                    {/* 이미지 */}
                                    <figure>
                                        <img
                                            src={getUniqNewsUrl(uniqFileName, fileFormat)}
                                            style={{ maxWidth: "500px", width: "100%", height: "auto", borderRadius: "1%", boxShadow: "0 2px 8px rgba(0,0,0,0.3)"}}
                                            alt={`독일뉴스 - ${newsTitle}`}
                                            onMouseEnter={e => e.currentTarget.style.transform="scale(1.01)"}
                                            onMouseLeave={e => e.currentTarget.style.transform="scale(1)"}
                                            itemProp="image"
                                            loading="lazy"
                                        />
                                        <figcaption>
                                            <div class="row" style={{ marginBottom: "30px" }}>
                                                <label class="form-label">
                                                    <span style={{ fontSize: '13px' }}>사진: {fileSource}</span>
                                                </label>
                                            </div>
                                        </figcaption>
                                    </figure>

                                    {/* 상세내용 */}
                                    <p class="card-text" itemProp="articleBody">
                                        <span style={{ color: '#222222' }}>
                                            {parse(newsContent)}
                                        </span><br /><br />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="container d-flex d-sm-flex justify-content-center align-items-center justify-content-sm-center align-items-sm-center" style={{ marginTop: '15px' }}>
                            <nav>
                                <ul class="pagination">
                                    <li class="page-item text-center d-flex d-md-flex d-xxl-flex justify-content-center justify-content-md-center align-items-md-center" style={{ textAlign: 'center' }} onClick={backToList}><a class="page-link">목록</a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </article>
            </main>
        </div>
    );
}